import { css } from "styled-components"

export const ourProcess = css`

  text-align: center;

  section {
    background-color: #FCEDBD;
    padding: 100px 0;

    & > div {
      position: relative;
    }
  }

  .background-box {
    background-color: white;
    width: 170px;
    height: 155px;
    border-radius: 0px 0px 40px 0px;
    position: absolute;
    z-index: 1;
    top: -100px;
    right: -170px;
  }

  p.text {
    font-size: 24px;
    line-height: 34px;
  }

  .section-title,
  .text {
    position: relative;
    z-index: 2;
  }

  .section-title {
    padding-top: 40px;
    font-size: 42px;

    @media (max-width: 768px) {
      font-size: 32px;
    }
  }

  .main-cta-btn {
    margin-top: 40px;
  }

`